import flow from "lodash/fp/flow";
import get from "lodash/fp/get";
import getOr from "lodash/fp/getOr";
import values from "lodash/fp/values";
import sum from "lodash/fp/sum";
import map from "lodash/fp/map";
import { head, sortBy } from "lodash/fp";

import selectUserChoiceValues from "./selectUserChoiceValues";
import selectUserChoices from "./selectUserChoices";
import selectSelectedProduct from "./selectSelectedProduct";
import selectDefaultValues from "./selectDefaultValues";
import { formatPrice, filterSkus } from "utils";

const divideBy100 = (n) => n / 100;

export default function selectProductCost(state) {
  const selectedCurrency = state.app.currency;
  const selectedProduct = selectSelectedProduct(state);
  const userChoicesValues = selectUserChoiceValues(state);
  const defaultValues = selectDefaultValues(state);
  const userChoices = selectUserChoices(state);
  const locale = state.app.locale;

  return flow(
    getOr({}, ["skus"]),
    values,
    (skus) => {
      const filteredSkus = filterSkus({
        ...defaultValues,
        ...userChoicesValues,
      })(skus);
      return filteredSkus.length > 0 ? filteredSkus : skus;
    },
    sortBy(get(["cost", selectedCurrency])),
    head,
    get(["cost", selectedCurrency]),
    (cost) => {
      return [
        cost,
        // get any price adjustments from selectedOptions
        ...map(getOr(0, ["selectedOption", "priceAdjust", selectedCurrency]))(
          userChoices
        ),
      ];
    },
    sum,
    divideBy100,
    formatPrice({
      style: "currency",
      currency: selectedCurrency,
      locale,
    })
  )(selectedProduct);
}
